export default __webpack_public_path__ + "static/media/Small.faa45b1d.svg";